import { all } from "redux-saga/effects";


// Saga creators
import createInitializeLoginSaga from "../../auth/store/initializeSaga";
import createLoginSaga from "../../auth/store/loginSaga";
import createLogoutSaga from "../../auth/store/logoutSaga";
import createSetLanguageSaga from "../../auth/store/setLanguageSaga";
import createAnonLoginSaga from "../../auth/store/anonLogin";

import createGetUsersAppRolesSaga from "../../auth/store/getUsersAppRoles";

import createFetchInitialContextSaga from "./fetchInitialContextSaga";
import createUpdateContextDataSaga from "./updateContextDataSaga";
import createFetchObservationCountsSaga from "./fetchObservationCountsSaga";

import createFetchObservationsSaga from "./fetchObservationListPageSaga";
import craeteFetchObservationListSaga from "./fetchObservationList";

import createFetchFormDefinitionSaga from "./fetchFormDefinitionSaga";
import createFetchCreateObservationSaga from "./fetchCreateObservationSaga";
import createFetchObservationSaga from "./fetchObservationSaga";
import createFetchSaveObservationProcessFormSaga from "./fetchSaveObservationProcessFormSaga";
import createFetchProcessorPersonsSaga from "./fetchProcessorPersons";
import createFetchPersonsSaga from "./fetchPersonsSaga";

import createFetchFormContextLocationsSaga from "./fetchFormContextLocations";
import craeteFetchDelegateObservationSaga from "./fetchDelegateObservation";

// Services
import { ISgAuthService } from "../../../../sg-auth/services/SgAuthService";
import { IContextService } from "../../services/contextService";
import { IObservationService } from "../../services/observationService";
import { IPersonService } from "../../services/personService";
import { IFormContextService } from "../../services/formContextService";


export default function createhavainnotSagas(
    authService: ISgAuthService,
    contextService: IContextService,
    observationService: IObservationService,
    personService: IPersonService,
    formContextService: IFormContextService
) {
    return function* havainnotSagas() {
        yield all([
            createInitializeLoginSaga(authService),
            createLogoutSaga(authService),
            createLoginSaga(),
            createSetLanguageSaga(),
            createAnonLoginSaga(authService),

            createGetUsersAppRolesSaga(contextService),
            createFetchInitialContextSaga(contextService),
            createUpdateContextDataSaga(),
            createFetchObservationCountsSaga(observationService),
            craeteFetchDelegateObservationSaga(),
            createFetchObservationsSaga(observationService),
            craeteFetchObservationListSaga(observationService),

            createFetchFormDefinitionSaga(contextService),
            createFetchCreateObservationSaga(observationService, personService),
            createFetchObservationSaga(observationService),
            createFetchSaveObservationProcessFormSaga(observationService),

            createFetchProcessorPersonsSaga(personService),
            createFetchPersonsSaga(),

            createFetchFormContextLocationsSaga(formContextService)
        ]);
    };
}